import { SBack, SListTabs } from 'shj-components'
import styles from '../index.module.less'
import { Button, message } from 'antd'
import { useSetState } from 'ahooks'
import ReQuoteSelection from './components/ReQuoteSelection'
import ShortageProducts from './components/ShortageProducts'
import { useEffect, useState } from 'react'
import { quoteBudgetItemTree } from '@/services/order'
import { useParams } from 'react-router-dom'
import { isArray } from 'lodash-es'
import { getBudgetPrintInfoMap } from '@/services/goods'
import ContractModal from '@/components/ContractModal'
import { getAuth } from '@/utils/btn.ts'

const ShortageGoods = () => {
  const budgetId = useParams().budgetId
  const [contractMap, setContractMap] = useState({})
  const [openContractModal, setOpenContractModal] = useState(false)
  const auths = getAuth() || {}
  
  // 基础配置
  const [state, setState] = useSetState<any>({
    activeKey: '',
    tabs: [],
    querytree: [],
  })

  useEffect(() => {
    quoteBudgetItemTree({
      params: {
        quoteBudgetId: budgetId,
      },
    }).then(res => {
      if (isArray(res)) {
        setState({
          tabs: res.map(item => {
            return {
              key: item.id,
              label: item.label,
              children:
                item.label === '缺断货产品' ? (
                  <ShortageProducts refItemId={item.id} />
                ) : (
                  <ReQuoteSelection refItemId={item.id} />
                ),
            }
          }),
          activeKey: res[0].id,
        })
      }
    })
  }, [])

  //  0. 返回
  const goBack = () => {
    localStorage.removeItem('quoteSelectionSearch')
    history.back()
  }
  //  1.发布合同
  const InitiateContract = async () => {
    try {
      if (budgetId) {
        const res = await getBudgetPrintInfoMap([budgetId])
        setContractMap(res || {})
        setOpenContractModal(true)
      } else {
        message.error('无报价ID')
      }
    } catch (err) {
      console.log(err)
    }
  }
  return (
    <SBack
      title={'缺断货变更'}
      level={2}
      goPath={goBack}
      extra={[
        <div className={styles.btns}>
          {
           auths['starting_contract'] && <Button type="primary" onClick={InitiateContract}>
              发起合同
            </Button>
          }
        </div>,
      ]}
    >
      <div className={styles.baseBox}>
        <SListTabs
          auth={false}
          items={state.tabs}
          activeKey={state.activeKey}
          onChange={(key: string) => setState({ activeKey: key })}
          hideExtra={false}
        />
      </div>

      {/* 发起合同 */}
      {openContractModal && (
        <ContractModal
          open={openContractModal}
          closeDialog={() => setOpenContractModal(false)}
          contractMap={contractMap}
        />
      )}
    </SBack>
  )
}
export default ShortageGoods
